import { isCSSStyleSheet, typeCheck } from "@knyt/artisan";
import { cssStyleSheetToString } from "./cssStyleSheetToString.js";
import { isCSSSerializable } from "./isCSSSerializable.js";
/**
 * Converts a recognized CSS value into a string.
 *
 * @internal scope: package
 */
export function cssIncludeToString(include) {
    if (typeof include === "string") {
        return include;
    }
    if (isCSSSerializable(include)) {
        return include.toCSSString();
    }
    if (isCSSStyleSheet(include)) {
        return cssStyleSheetToString(include);
    }
    // TODO: Remove in production
    typeCheck(typeCheck.identify(include));
    throw new TypeError(`Unsupported CSSInclude type: ${String(include)}`);
}
